import React from 'react';

import TalentAssessmentPage from 'components/Members/TalentAssessment/Views/Show/Index';

import StepTab from 'components/new_ui/Tabs/StepTab';
import routes from 'app/routes';

import { useContext } from 'components/Members/Programs/Views/Show/Context';

import { useNavigate } from 'react-router-dom';

export default function Index() {
  const navigate = useNavigate();
  const { state } = useContext();

  const onGoNextClick = () => {
    navigate(routes.members.programs.new.orderTopics(state.program.id));
  };

  return (

    <div className="onboarding-content">
      <StepTab total={5} current={1} />
      <TalentAssessmentPage onNextStep={onGoNextClick} />
    </div>
  );
}
